import usaid from '../assets/sponsors/usaid.webp';
import aks from '../assets/sponsors/aks.webp';
import gainLogo from '../assets/sponsors/gain_logo.webp';
import breweries from '../assets/sponsors/breweries.webp';
import nestle from '../assets/sponsors/nestle.webp';
import harvest from '../assets/sponsors/harvest.webp';
import gates from '../assets/sponsors/gates.webp';
import intlFoods from '../assets/sponsors/intl_foods.webp';
import unilever from '../assets/sponsors/unilever.webp';
import rivers from '../assets/sponsors/rivers.webp';
import nottingham from '../assets/sponsors/nottingham.webp';
import uniuyo from '../assets/sponsors/uniuyo.webp';
import ukaid from '../assets/sponsors/ukaid.webp';

const SPONSORS = [
  usaid,
  gainLogo,
  breweries,
  nestle,
  harvest,
  aks,
  gates,
  intlFoods,
  unilever,
  rivers,
  nottingham,
  uniuyo,
  ukaid,
];

export default SPONSORS;
